import { render, staticRenderFns } from "./ContentAdmin.vue?vue&type=template&id=9d01324c&scoped=true&"
import script from "./ContentAdmin.vue?vue&type=script&lang=js&"
export * from "./ContentAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ContentAdmin.vue?vue&type=style&index=0&id=9d01324c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d01324c",
  null
  
)

export default component.exports